// extracted by mini-css-extract-plugin
module.exports = {"timeStampWrap":"LV1PG"};